// Steps/UpsellReceptionistStep.jsx
// Only shown in "number" mode, right after purchase. Offers the AI Virtual
// Receptionist. The answer sets wizard.wantsReceptionist, which reshapes the
// step list (buildTelephonySteps) so the receptionist steps either follow or
// the wizard jumps straight to Summary.

import React from "react";
import PropTypes from "prop-types";
import { Card } from "reactstrap";

export function UpsellReceptionistStep({ wizard }) {
  const { purchasedNumber, setWantsReceptionist, goNext, goBack } = wizard;

  const choose = (wants) => {
    setWantsReceptionist(wants);
    // buildTelephonySteps recomputes on the next render; advancing lands on the
    // first receptionist step (yes) or Summary (no).
    goNext();
  };

  return (
    <div className="step-container">
      <div className="mb-4 pb-2 border-bottom">
        <h4 className="text-pastel-blue fw-bold mb-1">
          Add an AI Virtual Receptionist?
        </h4>
        <p className="text-muted small mb-0">
          Let AI answer{" "}
          <strong>{purchasedNumber || "your new number"}</strong> around the
          clock.
        </p>
      </div>

      <Card className="border-0 shadow-sm rounded-4 bg-white p-4 mb-3">
        <div className="d-flex align-items-start gap-3">
          <div
            className="bg-pastel-blue text-pastel-blue rounded-circle d-flex justify-content-center align-items-center flex-shrink-0"
            style={{ width: "48px", height: "48px" }}
          >
            <i className="ri-robot-2-line fs-4"></i>
          </div>
          <div>
            <h6 className="fw-bold text-dark mb-1">
              Never miss a call again
            </h6>
            <p className="text-muted mb-0 small">
              An AI receptionist answers inbound calls, greets callers in your
              company&apos;s voice, and handles enquiries 24/7. You can set it up
              in the next couple of steps.
            </p>
          </div>
        </div>
      </Card>

      <div className="d-flex align-items-center justify-content-between mt-4 pt-3 border-top">
        <button
          type="button"
          className="btn btn-light rounded-pill px-4 fw-semibold text-muted"
          onClick={goBack}
        >
          <i className="ri-arrow-left-line me-2"></i> Back
        </button>
        <div className="d-flex gap-2">
          <button
            type="button"
            className="btn btn-outline-secondary rounded-pill px-4 fw-semibold"
            onClick={() => choose(false)}
          >
            No thanks
          </button>
          <button
            type="button"
            className="btn btn-primary rounded-pill px-4 fw-semibold"
            onClick={() => choose(true)}
          >
            <i className="ri-robot-2-line me-2"></i> Yes, set it up
          </button>
        </div>
      </div>
    </div>
  );
}

UpsellReceptionistStep.propTypes = {
  wizard: PropTypes.object.isRequired,
};
